// useDeleteFreight.ts
import { useState } from 'react';
import { toast } from 'react-toastify';
import { api } from '../../services/api';

export default function useDeleteFreight() {
  const [loading, setLoading] = useState(false);

  const deleteFreight = async (id: string) => {
    try {
      setLoading(true);
      const response = await api.delete(`v1/backoffice/freights`, {
        data: [id],
      });
      setLoading(false);
      return response.data;
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error('Erro ao deletar frete');
    }
  };

  return { deleteFreight, loading };
}

